<template>
  <b-row>
    <b-col align="center">
      <h5 class="mb-5">관련 프로그램</h5>
      <b-card-group deck>
        <b-card
          v-for="current in currentClasses"
          :key="current.title"
          border-variant="primary"
          :footer="current.level"
          header-bg-variant="primary"
          header-text-variant="white"
          align="center"
        >
          <router-link
            :to="{
              name: 'curriculumshow',
              params: { id: current.id }
            }"
          >
            <b-card-text>{{ current.title }}</b-card-text>
          </router-link>
        </b-card>
      </b-card-group>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    id: {
      type: Number
    }
  },
  data() {
    return {
      totalClasses: {},
      currentClasses: {}
    };
  },
  created() {
    this.totalClasses = [
      {
        id: 0,
        title: "iOS 앱 디자인과 앱 개발과정",
        level: "Intermediate"
      },
      { id: 1, title: "코딩배우기 1& 2", level: "Beginner" },
      { id: 2, title: "App 기획자 UX 디자인 과정", level: "Beginner" }
    ];
    this.currentClasses = this.totalClasses.filter(e => e.id !== this.id);
  }
};
</script>

<style></style>
